import { createContext } from 'react';

const Context = createContext({ el: null });

export { Context };
